(function(){
  'use strict';

  var LABELS={
    circle:'Circle',square:'Square',rectangle:'Rectangle',rounded:'Rounded',heart:'Heart',
    star:'Star',hexagon:'Hexagon',diamond:'Diamond',triangle:'Triangle',bear:'Gummy Bear',custom:'Custom Design'
  };

  function clamp(value,min,max){return Math.max(min,Math.min(max,value));}
  function fmt(value,digits){
    return new Intl.NumberFormat(undefined,{maximumFractionDigits:digits==null?1:digits}).format(value);
  }

  function injectFixStyles(){
    if(document.querySelector('style[data-gmb-piece-fixes]'))return;
    var style=document.createElement('style');
    style.setAttribute('data-gmb-piece-fixes','');
    style.textContent='\n'+
      '[data-gmb] .gmb__field{min-width:0}\n'+
      '[data-gmb] .gmb__fields.three{grid-template-columns:repeat(3,minmax(0,1fr));align-items:start}\n'+
      '[data-gmb] .gmb__field>div{width:100%;min-width:0;overflow:hidden}\n'+
      '[data-gmb] .gmb__field>div input{flex:1 1 0;width:0;min-width:0;padding-left:9px;padding-right:8px}\n'+
      '[data-gmb] .gmb__field>div span{flex:0 0 auto;min-width:43px;justify-content:center;padding-left:7px;padding-right:7px;white-space:nowrap}\n'+
      '[data-gmb] .gmb__fields.three + h3{margin-top:23px;padding-top:17px;border-top:1px solid #ececea}\n'+
      '[data-gmb] .gmb__tabs{min-width:0}\n'+
      '[data-gmb] .gmb__tabs button{min-width:0;white-space:normal;line-height:1.25}\n'+
      '@media(max-width:430px){[data-gmb] .gmb__fields.three{grid-template-columns:1fr}}\n';
    document.head.appendChild(style);
  }

  function shapePath(ctx,shape,x,y,w,h){
    ctx.beginPath();
    if(shape==='circle'){
      ctx.ellipse(x+w/2,y+h/2,w/2,h/2,0,0,Math.PI*2);
    }else if(shape==='rounded'){
      var radius=Math.min(w,h)*0.22;
      if(typeof ctx.roundRect==='function')ctx.roundRect(x,y,w,h,radius);else roundedRect(ctx,x,y,w,h,radius);
    }else if(shape==='heart'){
      ctx.moveTo(x+w/2,y+h*.92);
      ctx.bezierCurveTo(x+w*.08,y+h*.69,x+w*.03,y+h*.27,x+w*.29,y+h*.17);
      ctx.bezierCurveTo(x+w*.45,y+h*.11,x+w*.5,y+h*.29,x+w*.5,y+h*.36);
      ctx.bezierCurveTo(x+w*.5,y+h*.29,x+w*.55,y+h*.11,x+w*.71,y+h*.17);
      ctx.bezierCurveTo(x+w*.97,y+h*.27,x+w*.92,y+h*.69,x+w/2,y+h*.92);
      ctx.closePath();
    }else if(shape==='star'){
      for(var i=0;i<10;i++){
        var angle=-Math.PI/2+i*Math.PI/5;
        var radiusStar=(i%2?.44:1)*Math.min(w,h)/2;
        var px=x+w/2+Math.cos(angle)*radiusStar;
        var py=y+h/2+Math.sin(angle)*radiusStar;
        if(i===0)ctx.moveTo(px,py);else ctx.lineTo(px,py);
      }
      ctx.closePath();
    }else if(shape==='hexagon'){
      ctx.moveTo(x+w*.25,y);ctx.lineTo(x+w*.75,y);ctx.lineTo(x+w,y+h/2);
      ctx.lineTo(x+w*.75,y+h);ctx.lineTo(x+w*.25,y+h);ctx.lineTo(x,y+h/2);ctx.closePath();
    }else if(shape==='diamond'){
      ctx.moveTo(x+w/2,y);ctx.lineTo(x+w,y+h/2);ctx.lineTo(x+w/2,y+h);ctx.lineTo(x,y+h/2);ctx.closePath();
    }else if(shape==='triangle'){
      ctx.moveTo(x+w/2,y);ctx.lineTo(x+w,y+h);ctx.lineTo(x,y+h);ctx.closePath();
    }else if(shape==='bear'){
      var r=Math.min(w,h);
      ctx.moveTo(x+w*.28,y+h*.22);
      ctx.arc(x+w*.22,y+h*.2,r*.115,0,Math.PI*2);
      ctx.moveTo(x+w*.895,y+h*.2);
      ctx.arc(x+w*.78,y+h*.2,r*.115,0,Math.PI*2);
      ctx.moveTo(x+w*.82,y+h*.55);
      ctx.ellipse(x+w*.5,y+h*.56,w*.31,h*.39,0,0,Math.PI*2);
    }else{
      ctx.rect(x,y,w,h);
    }
  }

  function roundedRect(ctx,x,y,w,h,r){
    r=Math.min(r,w/2,h/2);
    ctx.moveTo(x+r,y);ctx.lineTo(x+w-r,y);ctx.quadraticCurveTo(x+w,y,x+w,y+r);
    ctx.lineTo(x+w,y+h-r);ctx.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
    ctx.lineTo(x+r,y+h);ctx.quadraticCurveTo(x,y+h,x,y+h-r);
    ctx.lineTo(x,y+r);ctx.quadraticCurveTo(x,y,x+r,y);ctx.closePath();
  }

  function drawBackground(ctx,W,H){
    ctx.clearRect(0,0,W,H);
    var bg=ctx.createLinearGradient(0,0,0,H);
    bg.addColorStop(0,'#fbfcfd');
    bg.addColorStop(1,'#e8ecef');
    ctx.fillStyle=bg;
    ctx.fillRect(0,0,W,H);
    ctx.save();
    ctx.strokeStyle='rgba(36,43,51,.055)';
    ctx.lineWidth=1;
    for(var x=0;x<W;x+=48){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();}
    for(var y=0;y<H;y+=48){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}
    ctx.restore();
  }

  function drawDimensionH(ctx,x1,x2,y,label){
    ctx.save();
    ctx.strokeStyle='#7a838c';ctx.fillStyle='#535d66';ctx.lineWidth=1.5;
    ctx.beginPath();ctx.moveTo(x1,y);ctx.lineTo(x2,y);ctx.moveTo(x1,y-7);ctx.lineTo(x1,y+7);ctx.moveTo(x2,y-7);ctx.lineTo(x2,y+7);ctx.stroke();
    ctx.font='600 16px Arial, sans-serif';ctx.textAlign='center';ctx.textBaseline='bottom';ctx.fillText(label,(x1+x2)/2,y-6);
    ctx.restore();
  }

  function drawDimensionV(ctx,x,y1,y2,label){
    ctx.save();
    ctx.strokeStyle='#7a838c';ctx.fillStyle='#535d66';ctx.lineWidth=1.5;
    ctx.beginPath();ctx.moveTo(x,y1);ctx.lineTo(x,y2);ctx.moveTo(x-7,y1);ctx.lineTo(x+7,y1);ctx.moveTo(x-7,y2);ctx.lineTo(x+7,y2);ctx.stroke();
    ctx.translate(x-10,(y1+y2)/2);ctx.rotate(-Math.PI/2);
    ctx.font='600 16px Arial, sans-serif';ctx.textAlign='center';ctx.textBaseline='bottom';ctx.fillText(label,0,-5);
    ctx.restore();
  }

  function drawCustomPlaceholder(ctx,W,H,data){
    var w=Math.min(450,W*.62),h=Math.min(250,H*.48),x=(W-w)/2,y=(H-h)/2;
    ctx.save();
    ctx.fillStyle='#f7f8f9';ctx.strokeStyle='#c8cdd2';ctx.lineWidth=2;ctx.setLineDash([10,8]);
    ctx.fillRect(x,y,w,h);ctx.strokeRect(x,y,w,h);ctx.setLineDash([]);
    ctx.fillStyle='#20262d';ctx.font='700 26px Arial, sans-serif';ctx.textAlign='center';ctx.fillText('Custom design',W/2,y+h/2-18);
    ctx.fillStyle='#69717a';ctx.font='500 16px Arial, sans-serif';ctx.fillText(data.file?'Reference file attached':'Upload artwork or a 3D reference',W/2,y+h/2+18);
    ctx.font='500 14px Arial, sans-serif';ctx.fillText('Finished geometry is confirmed during engineering review.',W/2,y+h/2+46);
    ctx.restore();
  }

  function drawThcIcon(ctx,x,y,size,raised){
    ctx.save();
    ctx.translate(x,y);
    ctx.beginPath();ctx.moveTo(0,-size*.52);ctx.lineTo(size*.54,size*.42);ctx.lineTo(-size*.54,size*.42);ctx.closePath();
    if(raised){ctx.fillStyle='rgba(5,72,47,.72)';ctx.translate(0,4);ctx.fill();ctx.translate(0,-4);ctx.fillStyle='rgba(92,213,151,.42)';ctx.fill();}
    else{ctx.strokeStyle='rgba(4,78,51,.86)';ctx.lineWidth=Math.max(2,size*.06);ctx.stroke();}
    ctx.fillStyle='rgba(4,78,51,.90)';ctx.font='800 '+Math.max(11,size*.28)+'px Arial, sans-serif';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText('THC',0,size*.06);
    ctx.restore();
  }

  function drawMark(ctx,data,left,top,w,h,view3d){
    if(!data.mark||data.mark==='none')return;
    var note=(data.marknote||'').trim();
    var text=note||((data.mark==='raised'?'RAISED':'RECESSED')+' MARK');
    text=text.toUpperCase().replace(/\s+/g,' ').slice(0,28);
    var cx=left+w/2,cy=top+h*.53;
    var hasThc=/\bTHC\b/i.test(text);
    var maxTextW=w*(hasThc?.48:.68);
    var fontSize=clamp(w/(Math.max(7,text.length)*.64),15,34);
    ctx.save();
    shapePath(ctx,data.shape,left,top,w,h);ctx.clip();
    ctx.textAlign='center';ctx.textBaseline='middle';ctx.font='800 '+fontSize+'px Arial, sans-serif';
    if(data.mark==='raised'||data.mark==='custom'){
      ctx.fillStyle='rgba(3,62,42,.75)';ctx.fillText(text,cx+(hasThc?w*.075:0),cy+5);
      ctx.fillStyle='rgba(119,232,174,.38)';ctx.fillText(text,cx+(hasThc?w*.075:0),cy-1);
      ctx.fillStyle='rgba(5,87,57,.92)';ctx.fillText(text,cx+(hasThc?w*.075:0),cy+1);
    }else{
      ctx.fillStyle='rgba(151,241,194,.34)';ctx.fillText(text,cx+(hasThc?w*.075:0),cy-2);
      ctx.fillStyle='rgba(1,58,38,.88)';ctx.fillText(text,cx+(hasThc?w*.075:0),cy+2);
    }
    if(hasThc)drawThcIcon(ctx,left+w*.29,cy,Math.min(w,h)*.24,data.mark==='raised'||data.mark==='custom');
    ctx.restore();
  }

  function drawFinishedPiece(root){
    var gummyButton=root.querySelector('[data-mode="gummy"]');
    var gummyMode=Boolean(gummyButton&&gummyButton.classList.contains('on'));
    var title=root.querySelector('.gmb__visual-title b');
    var subtitle=root.querySelector('.gmb__visual-title small');
    if(gummyButton&&gummyButton.textContent!=='Gummy')gummyButton.textContent='Gummy';
    if(!gummyMode){
      if(title)title.textContent='Live Mold Plan';
      if(subtitle)subtitle.textContent='Preliminary visualization';
      return;
    }

    var data=root._data;
    var canvas=root.querySelector('[data-canvas]');
    if(!data||!canvas)return;
    var ctx=canvas.getContext('2d');
    var W=canvas.width,H=canvas.height;
    var view3d=Boolean(root.querySelector('[data-view="3d"].on'));

    if(title)title.textContent='Finished Gummy Preview';
    if(subtitle)subtitle.textContent=view3d?'Finished-piece concept · 3D view':'Finished-piece concept · top view';

    drawBackground(ctx,W,H);
    if(data.shape==='custom'){
      drawCustomPlaceholder(ctx,W,H,data);
      var customBadge=root.querySelector('[data-badge]');
      if(customBadge)customBadge.textContent='Custom design · engineering review';
      return;
    }

    var xMm=Math.max(.01,Number(data.x)||25);
    var yMm=Math.max(.01,Number(data.y)||25);
    var zMm=Math.max(.01,Number(data.z)||10);
    var ratio=clamp(xMm/yMm,.30,3.4);
    var maxW=W*.62;
    var maxPlanH=H*(view3d?.70:.66);
    var planW=maxW;
    var planH=planW/ratio;
    if(planH>maxPlanH){planH=maxPlanH;planW=planH*ratio;}
    planW=Math.max(170,planW);planH=Math.max(115,planH);

    var topW=planW;
    var topH=view3d?planH*.62:planH;
    var depth=view3d?clamp((zMm/Math.max(xMm,yMm))*Math.min(planW,planH)*.92,34,128):0;
    var totalH=topH+depth;
    var left=(W-topW)/2;
    var top=(H-totalH)/2-12;
    top=clamp(top,46,H-totalH-58);

    if(view3d){
      ctx.save();ctx.filter='blur(12px)';ctx.globalAlpha=.22;ctx.fillStyle='#28323a';
      ctx.beginPath();ctx.ellipse(W/2,top+totalH+24,topW*.43,Math.max(16,topH*.12),0,0,Math.PI*2);ctx.fill();ctx.restore();

      var layers=Math.max(20,Math.round(depth/3));
      for(var layer=layers;layer>=1;layer--){
        var offset=depth*(layer/layers);
        shapePath(ctx,data.shape,left,top+offset,topW,topH);
        var side=ctx.createLinearGradient(left,top,left+topW,top+depth);
        side.addColorStop(0,'#0b5b3e');side.addColorStop(.50,'#0f7650');side.addColorStop(1,'#084c34');
        ctx.fillStyle=side;ctx.fill();
      }
    }

    shapePath(ctx,data.shape,left,top,topW,topH);
    var topGradient=ctx.createLinearGradient(left,top,left+topW,top+topH);
    topGradient.addColorStop(0,'#58ce99');topGradient.addColorStop(.34,'#28a76f');topGradient.addColorStop(1,'#0b7350');
    ctx.fillStyle=topGradient;ctx.fill();
    ctx.strokeStyle='rgba(5,75,50,.78)';ctx.lineWidth=2;ctx.stroke();

    ctx.save();shapePath(ctx,data.shape,left,top,topW,topH);ctx.clip();
    var shine=ctx.createRadialGradient(left+topW*.30,top+topH*.22,6,left+topW*.30,top+topH*.22,topW*.46);
    shine.addColorStop(0,'rgba(255,255,255,.38)');shine.addColorStop(.38,'rgba(255,255,255,.10)');shine.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=shine;ctx.fillRect(left,top,topW,topH);ctx.restore();

    drawMark(ctx,data,left,top,topW,topH,view3d);

    var dimY=Math.min(H-30,top+topH+depth+50);
    drawDimensionH(ctx,left,left+topW,dimY,fmt(xMm,2)+' mm');
    drawDimensionV(ctx,left-42,top,top+topH,fmt(yMm,2)+' mm');
    if(view3d)drawDimensionV(ctx,left+topW+42,top+topH,top+topH+depth,fmt(zMm,2)+' mm depth');

    var badge=root.querySelector('[data-badge]');
    if(badge){
      var markSuffix=data.mark&&data.mark!=='none'?' · '+(data.mark==='recessed'?'recessed mark':'raised mark'):'';
      badge.textContent=(LABELS[data.shape]||'Finished gummy')+' · '+fmt(xMm,2)+' × '+fmt(yMm,2)+' × '+fmt(zMm,2)+' mm'+markSuffix;
    }
  }

  function schedule(root){
    window.setTimeout(function(){
      try{drawFinishedPiece(root);}catch(error){
        if(window.console&&console.error)console.error('Gummy Molds finished-piece preview:',error);
      }
    },0);
  }

  function enhance(root){
    if(root.dataset.piecePreviewReady==='1')return;
    root.dataset.piecePreviewReady='1';
    var gummyButton=root.querySelector('[data-mode="gummy"]');
    if(gummyButton)gummyButton.textContent='Gummy';
    root.addEventListener('click',function(event){
      if(event.target.closest('[data-mode],[data-view],[data-reset],[data-next],[data-prev],[data-go]'))schedule(root);
    });
    root.addEventListener('input',function(){schedule(root);});
    root.addEventListener('change',function(){schedule(root);});
    schedule(root);
  }

  function boot(){
    injectFixStyles();
    document.querySelectorAll('[data-gmb]').forEach(enhance);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
